export enum NumberSuffixTranslateEnum {
	/** Thousands (e.g., 1K = 1,000) */
	K = 'compactNumber.thousand',

	/** Millions (e.g., 1M = 1,000,000) */
	M = 'compactNumber.million',

	/** Billions (e.g., 1B = 1,000,000,000) */
	B = 'compactNumber.billion',

	/** Trillions (e.g., 1T = 1,000,000,000,000) */
	T = 'compactNumber.trillion',
}
